import { Component, OnInit, ViewEncapsulation, Input, Renderer2, OnDestroy } from '@angular/core';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class LoaderComponent implements OnInit, OnDestroy {
  @Input() loadingtext: string;
  extraClasses: string = 'noscroll hidemopinion';

  constructor(private renderer: Renderer2) { }

  ngOnInit() {
    this.extraClasses.split(' ').forEach((className: string) => {
      this.renderer.addClass(document.body.parentElement, className);
      this.renderer.addClass(document.body, className);
    });
  }

  ngOnDestroy() {
    this.renderer.removeClass(document.body.parentElement, 'noscroll');
    this.renderer.removeClass(document.body, 'noscroll');

    setTimeout(() => {
      this.renderer.removeClass(document.body.parentElement, 'hidemopinion');
      this.renderer.removeClass(document.body, 'hidemopinion');
    }, 1000);
  }
}